module.exports = __webpack_public_path__ + "static/second-6f4f7e83ee60746be1ee3d0fb6fd0f46.jpg";